import { useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  ScoredAnswerQuestion3,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion
} from "./base/BaseQuestion";


import { StepButton } from "./step-button";
import { Form } from "antd";
const stringVehicles = [
  "Đi bộ",
  "Xe đạp",
  `Phương tiện công cộng`,
  `Xe máy cá nhân`,
  "Xe ôm",
  `Ô tô cá nhân`,
  "Taxi",
  `Dịch vụ gọi xe (Xe máy)`,
  `Dịch vụ gọi xe (Ô tô)`,
  "Khác",
];
const vehicles = [
  "Đi bộ",
  "Xe đạp",
  <span>
    Phương tiện
    <br />
    công cộng
  </span>,
  <span>
    Xe máy
    <br />
    cá nhân
  </span>,
  "Xe ôm",
  <span>
    Ô tô
    <br />
    cá nhân
  </span>,
  "Taxi",
  <span>
    Dịch vụ gọi xe
    <br />
    (Xe máy)
  </span>,
  <span>
    Dịch vụ gọi xe
    <br />
    (Ô tô)
  </span>,
  "Khác",
];
export const Section3 = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 3;
  const [nextStep, setNextStep] = useState();

  return (
    <div className="text-left" style={{ textAlign: "justify" }}>
      <Title index={majorIndex} content={title} />

      <Form
        onFinish={(value) => handleSubmit(value, nextStep)}
        onFinishFailed={handleFail}
      >
        {/* question 7 */}
        <ScoredAnswerQuestion1
          majorIndex={majorIndex}
          mirrorIndex={1}
          question={<span>Đánh giá Giá trị và các nguyên tắc định hướng của bản thân</span>}
          rawQuestion={"Đánh giá Giá trị và các nguyên tắc định hướng của bản thân"}
          answers={[
            "Niềm vui: Tận hưởng hạnh phúc và thỏa mãn trong cuộc sống",
            "Tận hưởng cuộc sống: Sống vô tư, không lo lắng",
            "Tự nuông chiều: Đáp ứng những mong muốn cá nhân",
            "Quyền lực xã hội: Kiểm soát và có ảnh hưởng đến người khác",
            "Giàu có: Thành công tài chính, sở hữu nhiều tài sản",
            "Quyền uy: Giữ vị trí lãnh đạo, có khả năng kiểm soát",
            "Ảnh hưởng: Được tôn trọng và ngưỡng mộ",
            "Tham vọng: Đặt và đạt được mục tiêu lớn",
            "Bình đẳng: Công bằng cho tất cả mọi người",
            "Một thế giới hòa bình: Không có xung đột, toàn cầu hòa hợp",
            "Công bằng xã hội: Thúc đẩy sự công bằng, lẽ phải",
            "Sẵn sàng giúp đỡ: Hỗ trợ và giúp đỡ người khác",
            "Tôn trọng trái đất: Trân trọng và bảo vệ trái đất",
            "Hòa hợp với thiên nhiên: Được kết nối và cảm nhận thiên nhiên",
            "Bảo vệ môi trường: Bảo tồn tài nguyên và môi trường sống",
            "Ngăn ngừa ô nhiễm: Giảm thiểu và tránh gây ô nhiễm"
          ]}
        />
        <BaseQuestion
          majorIndex={majorIndex}
          mirrorIndex={2}
          question={"Đánh giá Thái độ đối với việc sử dụng metro"}
        />

        <ScoredAnswerQuestion2
          majorIndex={undefined}
          mirrorIndex={undefined}
          question=""
          rawQuestion={"Đánh giá Thái độ đối với việc sử dụng metro"}

          answers={[
            "Thái độ của tôi đối với việc đi lại bằng metro là...",
          ]}
        />
        <ScoredAnswerQuestion3
          majorIndex={undefined}
          mirrorIndex={undefined}
          question=""
          rawQuestion={"Đánh giá Thái độ đối với việc sử dụng metro"}
          answers={[
            "Tôi thấy việc di chuyển bằng metro là thuận tiện",
            "Tôi thấy việc di chuyển bằng metro giúp tiết kiệm chi phí",
            "Tôi thấy việc di chuyển bằng metro là an toàn và đỡ căng thẳng",
            "Tôi thấy việc di chuyển metro thân thiện với môi trường",
          ]}
        />

        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={3}
          question={<span>Đánh giá Chuẩn mực chủ quan đối với việc sử dụng metro</span>}
          rawQuestion={"Đánh giá Thái độ đối với việc sử dụng metro"}
          answers={[
            "Hầu hết những người quan trọng đối với tôi sẽ không có vấn đề gì nếu tôi chọn di chuyển bằng metro",
            "Hầu hết những người quan trọng đối với tôi sẽ ủng hộ nếu tôi muốn di chuyển bằng metro",
            "Hầu hết những người quan trọng đối với tôi khuyên tôi nên di chuyển bằng metro",
            "Hầu hết những người quan trọng đối với tôi sẽ di chuyển bằng metro nếu họ ở trong tình huống của tôi",
            "Hầu hết những người quan trọng đối với tôi có khả năng sẽ chọn di chuyển bằng metro thường xuyên",
          ]}
        />

        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={4}
          question={<span>Đánh giá Kiểm soát Hành vi Nhận thức đối với việc sử dụng metro</span>}
          rawQuestion={"Đánh giá Kiểm soát Hành vi Nhận thức đối với việc sử dụng metro"}
          answers={[
            "Tôi tự tin rằng nếu muốn, tôi hoàn toàn có thể di chuyển bằng metro",
            "Việc tôi di chuyển bằng metro không hoàn toàn phụ thuộc vào tôi",
            "Tôi muốn di chuyển bằng metro thường xuyên, nhưng việc sắp xếp lịch trình là khó khăn và là một trở ngại",
            "Tôi có đủ kinh phí để di chuyển bằng metro",
          ]}
        />

        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={5}

          question={<span>Hành vi di chuyển trong quá khứ</span>}
          rawQuestion={"Hành vi di chuyển trong quá khứ"}
          answers={[
            "Tôi chủ yếu sử dụng phương tiện cá nhân cho phần lớn các chuyến đi hàng ngày",
            "Tôi hiếm khi sử dụng phương tiện giao thông công cộng cho các chuyến đi hàng ngày",
          ]}
        />
        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={6}
          question={<span>Đánh giá mong muốn di chuyển bằng metro</span>}
          rawQuestion={"Đánh giá mong muốn di chuyển bằng metro"}
          answers={[
            "Tôi rất muốn di chuyển bằng metro vì nó có vẻ tiện lợi và hữu ích",
            "Tôi cảm thấy có động lực mạnh mẽ để sử dụng metro thường xuyên hơn trong tương lai",
            "Tôi sẵn sàng sử dụng metro cho các chuyến đi hàng ngày của mình",
            "Tôi muốn sử dụng metro nhiều hơn so với phương tiện di chuyển hiện tại",
            "Tôi cảm thấy hài lòng khi nghĩ đến việc sẽ sử dụng metro lâu dài",
          ]}
        />
        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={7}
          question={<span>Đánh giá ý định di chuyển bằng metro</span>}
          rawQuestion={"Đánh giá ý định di chuyển bằng metro"}
          answers={[
            "Tôi sẽ di chuyển bằng metro nếu trong tương lai có những chương trình miễn phí hoặc giảm giá",
            "Tôi sẽ sắp xếp thời gian và tiền bạc của mình để thử di chuyển bằng metro trong tương lai gần",
            "Tôi sẽ nỗ lực để sử dụng metro như một thói quen trong tương lai gần",
            "Tôi dự định sử dụng metro bất cứ khi nào có thể trong tương lai gần",
            "Tôi dự định mua vé tháng của metro trong tương lai gần",
            "Tôi sẽ tiếp tục di chuyển bằng metro ngay cả khi có thể di chuyển bằng phương tiện cá nhân",
          ]}
        />
        <ScoredAnswerQuestion3
          majorIndex={majorIndex}
          mirrorIndex={8}
          question={<span>Đánh giá Mâu thuẫn nhận thức đối với việc di chuyển bằng metro</span>}
          rawQuestion={"Đánh giá Mâu thuẫn nhận thức đối với việc di chuyển bằng metro"}
          answers={[
            "Tôi không chắc liệu việc sử dụng metro có đáp ứng được nhu cầu di chuyển của tôi hay không",
            "Di chuyển bằng metro không thoải mái như phương tiện đi lại hiện tại của tôi",
            "Chương trình miễn phí trải nghiệm trong 15 ngày đầu của metro rất thu hút",
            "Trải nghiệm di chuyển bằng metro không như kỳ vọng",
            "Tôi băn khoăn liệu việc di chuyển thường xuyên bằng metro có phải là một quyết định đúng đắn hay không",
            "Tôi cảm thấy mâu thuẫn về việc liệu có nên tiếp tục di chuyển bằng phương tiện cá nhân hay không",
            "Tôi cảm thấy không thoải mái nếu metro gặp phải các vấn đề như quá đông, chậm trễ, v.v.",
            "Tôi không có lựa chọn nào khác ngoài việc sử dụng metro để tiết kiệm chi phí",
            "Nếu di chuyển bằng metro, tôi sẽ cảm thấy khó chịu khi không thể tham gia cùng những người khác di chuyển bằng phương tiện cá nhân",
          ]}
        />











        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>
      <br />
        <br />
        <br />
    </div>
  );
};
